import { MockDebug } from '@tino-frontend/mocks'
import { REACT_APP_MERCHANT_BFF_API_URL } from 'constants/envs'

const MockPaymentObligations: MockDebug = {
  title: 'List Payment Obligations',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v1/company/:companyId/payment-obligations?company_id=:compayId&limit=60&status=paid`,
  method: 'get',
  delay: 1000,
  options: [
    {
      id: 'mock-payment-obligations-overdue',
      title: 'Overdue',
      status: 200,
      data: {
        payment_obligations: [
          {
            id: '00000000-0000-0000-0000-000027144736',
            category: 'purchase_installment',
            external_id: 'e71a0597-be3c-4265-8ee6-d3bdaa0a6dca',
            company_id: 'b7221047-660e-4ca8-bf47-1a2197765017',
            amount: 1007,
            fine_amount: 30,
            paid_amount: 0,
            description: 'John Wick Seller Ltda. (2 de 2)',
            status: 'pending',
            created_by: 'merchant-invoice-ops',
            transaction_id: 'caff9c2f-1bd5-4e3e-bad2-c003e5235309',
            due_date: '2024-12-30',
            expiration_date: '2024-12-30',
            method: '',
            method_id: '',
            payment_notificated_at: null,
            paid_at: null,
            cancelled_at: null,
            created_at: '2024-12-03T21:28:05Z',
            updated_at: '2025-05-30T11:37:58.78944Z',
            pix: {
              id: '00000000-0000-0000-0000-000027144736',
              key: 'fa30beee-9a54-4f1b-9cb4-56fd19d3448f',
              emv: '00020101021226770014BR.GOV.BCB.PIX2555api.itau/pix/qr/v2/1209745a-2f9b-4692-8aff-51dee9e513625204000053039865802BR5925TINO INSTITUICAO DE PAGAM6009SAO PAULO62070503***6304C759',
              qr_code_base64:
                'iVBORw0KGgoAAAANSUhEUgAAAPoAAAD6AQAAAACgl2eQAAACxUlEQVR4Xu2WQW4lIQwF4SL4/reYo8BFYKrMKC39RTSLjGfTpKN8oL70Yj/b3c7361f7PPlYL3DXC9z1Anf9HTBb67PvNmKPFrv1M2N5WAgsnj1ixu5zdKEzu4eVANvZD+pm42LzcXhSDSwuAmq2jNWI/wGoca1UOUfcw0rAZ3oIxwWRWvewDtCf63N9uvrz/ocB1x6jNbO1drr3z3EZMFuoytJ14Zewjp5kFQDYlbuhsLVuD+F+aJsywJZlwYbhih1L/86uhcoAzKEo2lcoMvIXvacQYJGZLBdQQjZSYBJVwDIxROsYruzn/faQQmAz0FDGhTbp9tKukU8hwEbbZohCBxunfYkqgDQhrNNBxx0n4Xd4CoFJfJBkDzE+2zLGP6SuDuACz7DddjHKd1jKFk8dwDQlQ3llDTtjkcqmEEClp+E0RadqyZWlUwcsDWtgcqDZQbfF/IgsAHaOMpvW5EPXPX5IlVVA9lArVtcg9GTGso+WAdMZFkutfiBaDWIlUQVoFLuHp8fWkS8X/tQBmSwbWS57SVYx5q0DNC2nVo0DTaVh7T7/RQFAmKaVo1GyeGwk42nmBQBmMUrEh6drWmIEY6SqgGxi9Aze8Y51g123jvkKVAHgAHG3fbcgSJ6EnbUS6IZpRpbxHfF2E+/LAFpHGKxzM8QN7rWhFwIYxOu0q1Vj2KRKgZ36kLqzg7V+PexVFaC0lRodZMkBdiNXBjDE3KNtpU8cLcPKKQSMEcjVdpWaqSdQFUDL8KzJ32mS0j5Trgxwi089wih08W7eGPSFgIuNl5Yut/awrOYyQEHHUeIrhtOtW87LL5UByz52S2alVEELqRJA0jE/SFTvtplj4FMM8DjaKRp7qEauB1ZOlazj3MC1L8NUAMlgnJGeoa+SJ5BH5L8HzJDtgvINrIthuv7xO2XAd+sF7nqBu17grh8AfgO2uACB8OOMfgAAAABJRU5ErkJggg==',
              source: 'itau',
              source_id: '27144736',
            },
            boleto: {
              id: '00000000-0000-0000-0000-000027144736',
              digitable_line: '34191090080075721018259938050008697920000091617',
              barcode: '34196979200000916171090000757210185993805000',
              source: 'starkbank',
              source_id: '27144736',
              link: 'https://storage.googleapis.com/stg.boletino.storage.truepay.app/merchants/b7221047-660e-4ca8-bf47-1a2197765017/installment/e71a0597-be3c-4265-8ee6-d3bdaa0a6dca?generation=1733261293524999',
            },
          },
          {
            id: '00000000-0000-0000-0000-000043259871',
            category: 'purchase_installment',
            external_id: '8b7a7b09-ea1c-4e8b-ba04-4f922af814fc',
            company_id: 'b7221047-660e-4ca8-bf47-1a2197765017',
            amount: 1008,
            fine_amount: 30,
            paid_amount: 0,
            description: 'John Wick Seller Ltda. (1 de 2)',
            status: 'pending',
            created_by: 'merchant-invoice-ops',
            transaction_id: '6173666f-4634-4fd3-ae04-5c6514b332e7',
            due_date: '2024-12-16',
            expiration_date: '2024-12-16',
            method: '',
            method_id: '',
            payment_notificated_at: null,
            paid_at: null,
            cancelled_at: null,
            created_at: '2024-12-03T21:27:47Z',
            updated_at: '2025-05-30T11:37:58.928063Z',
            pix: {
              id: '00000000-0000-0000-0000-000043259871',
              key: 'fa30beee-9a54-4f1b-9cb4-56fd19d3448f',
              emv: '00020101021226770014BR.GOV.BCB.PIX2555api.itau/pix/qr/v2/1209745a-2f9b-4692-8aff-51dee9e513625204000053039865802BR5925TINO INSTITUICAO DE PAGAM6009SAO PAULO62070503***6304C759',
              qr_code_base64:
                'iVBORw0KGgoAAAANSUhEUgAAAPoAAAD6AQAAAACgl2eQAAACxUlEQVR4Xu2WQW4lIQwF4SL4/reYo8BFYKrMKC39RTSLjGfTpKN8oL70Yj/b3c7361f7PPlYL3DXC9z1Anf9HTBb67PvNmKPFrv1M2N5WAgsnj1ixu5zdKEzu4eVANvZD+pm42LzcXhSDSwuAmq2jNWI/wGoca1UOUfcw0rAZ3oIxwWRWvewDtCf63N9uvrz/ocB1x6jNbO1drr3z3EZMFuoytJ14Zewjp5kFQDYlbuhsLVuD+F+aJsywJZlwYbhih1L/86uhcoAzKEo2lcoMvIXvacQYJGZLBdQQjZSYBJVwDIxROsYruzn/faQQmAz0FDGhTbp9tKukU8hwEbbZohCBxunfYkqgDQhrNNBxx0n4Xd4CoFJfJBkDzE+2zLGP6SuDuACz7DddjHKd1jKFk8dwDQlQ3llDTtjkcqmEEClp+E0RadqyZWlUwcsDWtgcqDZQbfF/IgsAHaOMpvW5EPXPX5IlVVA9lArVtcg9GTGso+WAdMZFkutfiBaDWIlUQVoFLuHp8fWkS8X/tQBmSwbWS57SVYx5q0DNC2nVo0DTaVh7T7/RQFAmKaVo1GyeGwk42nmBQBmMUrEh6drWmIEY6SqgGxi9Aze8Y51g123jvkKVAHgAHG3fbcgSJ6EnbUS6IZpRpbxHfF2E+/LAFpHGKxzM8QN7rWhFwIYxOu0q1Vj2KRKgZ36kLqzg7V+PexVFaC0lRodZMkBdiNXBjDE3KNtpU8cLcPKKQSMEcjVdpWaqSdQFUDL8KzJ32mS0j5Trgxwi089wih08W7eGPSFgIuNl5Yut/awrOYyQEHHUeIrhtOtW87LL5UByz52S2alVEELqRJA0jE/SFTvtplj4FMM8DjaKRp7qEauB1ZOlazj3MC1L8NUAMlgnJGeoa+SJ5BH5L8HzJDtgvINrIthuv7xO2XAd+sF7nqBu17grh8AfgO2uACB8OOMfgAAAABJRU5ErkJggg==',
              source: 'itau',
              source_id: '43259871',
            },
            boleto: {
              id: '00000000-0000-0000-0000-000043259871',
              digitable_line: '34191090080075721018259938050008697920000091617',
              barcode: '34196979200000916171090000757210185993805000',
              source: 'starkbank',
              source_id: '43259871',
              link: 'https://storage.googleapis.com/stg.boletino.storage.truepay.app/merchants/b7221047-660e-4ca8-bf47-1a2197765017/installment/8b7a7b09-ea1c-4e8b-ba04-4f922af814fc?generation=1733261280228892',
            },
          },
        ],
        pagination_cursor: {
          id: 0,
          created_at: '2023-12-28T10:00:00Z',
        },
      },
    },
    {
      id: 'mock-payment-obligations-paid',
      title: 'Paid',
      status: 200,
      data: {
        payment_obligations: [
          {
            id: '10',
            description: 'Atacadista 123',
            due_date: '2024-01-01',
            amount: 15600,
            status: 'paid',
            fine_amount: 1640,
            paid_amount: 17240,
            paid_at: '2024-01-02T10:00:00Z',
            method: 'pix',
            method_id: 'method-1',
          },
          {
            id: '11',
            description: 'Fornecedor DEF',
            due_date: '2023-12-28',
            amount: 27500,
            status: 'paid',
            paid_amount: 27500,
            paid_at: '2023-12-29T15:30:00Z',
            method: 'boleto',
            method_id: 'method-1',
          },
          {
            id: '12',
            description: 'Distribuidor GHI',
            due_date: '2023-12-25',
            amount: 18900,
            status: 'paid',
            paid_amount: 18900,
            paid_at: '2023-12-26T09:15:00Z',
            method: 'pix',
            method_id: 'method-1',
          },
        ],
        pagination_cursor: {
          id: 0,
          created_at: '2023-12-28T10:00:00Z',
        },
      },
    },
    {
      id: 'mock-payment-obligations-onTime',
      title: 'On Time',
      status: 200,
      data: {
        payment_obligations: [
          {
            id: '1',
            description: 'Riberfoods (1 de 2)',
            due_date: '2025-08-15',
            amount: 18628,
            fine_amount: 0,
            paid_amount: 0,
            status: 'pending',
            method: 'pix',
            method_id: 'method-1',
            pix: {
              id: 'pix-1',
              key: '12345678900',
              emv: '0002012658...',
              qr_code_base64: 'base64string',
              source: 'pix',
              source_id: 'pix-1',
            },
          },
          {
            id: '2',
            description: 'Rio Quality',
            due_date: '2025-08-01',
            amount: 10000,
            fine_amount: 0,
            paid_amount: 0,
            status: 'pending',
            method: 'boleto',
            method_id: 'method-2',
            boleto: {
              id: 'boleto-1',
              digitable_line:
                '34191.09008 00001.234567 89012.345678 9 12345678901234',
              barcode: '34191234567890123456789012345678901234567890',
              source: 'boleto',
              source_id: 'boleto-1',
              link: 'https://boleto.example.com/123',
            },
          },
          {
            id: '8',
            description: 'Fornecedor ABC',
            due_date: '2025-08-10',
            amount: 45000,
            status: 'pending',
            fine_amount: 2250,
            paid_amount: 0,
            method: 'boleto',
            method_id: 'method-8',
            boleto: {
              id: 'boleto-1',
              digitable_line:
                '34191.09008 00001.234567 89012.345678 9 12345678901234',
              barcode: '34191234567890123456789012345678901234567890',
              source: 'boleto',
              source_id: 'boleto-1',
              link: 'https://boleto.example.com/123',
            },
          },
        ],
        pagination_cursor: {
          id: 0,
          created_at: '2023-12-28T10:00:00Z',
        },
      },
    },
  ],
}

export const MockDebugPaymentObligations = [MockPaymentObligations]
